/**
 * 同行者追加検索の種類
 * - ORDER: 予約番号
 * - E_TICKET: 航空券番号
 */
export type PassengerSearchType = (typeof PassengerSearchType)[keyof typeof PassengerSearchType];

export const PassengerSearchType = {
  ORDER: 0,
  E_TICKET: 1,
} as const;
